module.exports = __webpack_public_path__ + "static/img/zapier.0326de0.png";